// Registration

// Object 'assign' method IE polyfill
/*
import "core-js/es6";
import "regenerator-runtime/runtime";*/

import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required, email, sameAs, maxLength } from 'vuelidate/lib/validators';
import VueProgressBar from 'vue-progressbar'; // freshly installed for this component
import axios from 'axios';

Vue.use(Vuelidate);

const options = {
  color: '#fc0c94',
  thickness: '4px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
  position: 'absolute'
}

Vue.use(VueProgressBar, options);

// Show alert when not activation hours
  $(function(){
    if ($(".AlertNotActivationTime").length )
    {
      const currentHour = new Date().getHours();
      if ( currentHour < 8 || currentHour >= 18 )
      {
        $(".AlertNotActivationTime").removeClass('d-none');
      }
    }
  });
// __ Show alert when not activation hours __

const registrationFrame = document.querySelector('#registrationFrame');
if (registrationFrame) {
  new Vue({
    el: '#registrationFrame',
    data: () => ({
      step: 1,
      session: null,
      isAlertOpen: false,
      stepOneForm: {
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        gender: '',
        isBusinessAgreement: false,
        isMarketingAgreement: false
      },
      stepTwoForm: {
        birthNumber: '',
        address: '',
        isFeedbackAgreement: false,
        isGDPRAgreement: false
      },
      stepThreeForm: {
        promoCode: '',
        healthCard: {
          fileContent: ''
        },
        FileInputExceeded: false,
        FileInputDragOver: false
      },
      stepResponse: null,
      isNextDisabled: false
    }),
    mounted() {
      // ga tracking
      this.gaStepsTrack();

      // fill default values from backend if we have any
      if ( this.$refs.InputFirstName.dataset.value )
      {
        this.stepOneForm.firstname = this.$refs.InputFirstName.dataset.value;
      }

      if ( this.$refs.InputLastName.dataset.value )
      {
        this.stepOneForm.lastname = this.$refs.InputLastName.dataset.value;
      }

      if ( this.$refs.InputPhoneNumber.dataset.value )
      {
        this.stepOneForm.phone = this.$refs.InputPhoneNumber.dataset.value;
      }

      if ( this.$refs.InputEmail.dataset.value )
      {
        this.stepOneForm.email = this.$refs.InputEmail.dataset.value;
      }

      if ( this.$refs.GenderInputMale.dataset.checked )
      {
        this.stepOneForm.gender = this.$refs.GenderInputMale.value;
      }

      if ( this.$refs.GenderInputFemale.dataset.checked )
      {
        this.stepOneForm.gender = this.$refs.GenderInputFemale.value;
      }
    },
    validations: {
      stepOneForm: {
        firstname: {
          required
        },
        lastname: {
          required
        },
        phone: {
          required,
        },
        email: {
          required,
          email
        },
        gender: {
          required
        },
        isBusinessAgreement: {
          sameAs: sameAs( () => true )
        },
        isMarketingAgreement: {

        },
      },
      stepTwoForm: {
        birthNumber: {
          required,
        },
        address: {
          required
        },
        isFeedbackAgreement: {

        },
        isGDPRAgreement: {
          sameAs: sameAs( () => true )
        },
      },
      stepThreeForm: {
        promoCode: {
          maxLength: maxLength(20)
        },
      }
    },
    methods: {
      stepNext() {
        if (this.step < 5) {
          this.$refs.registrationFrame.scrollTop = 0;
          this.alertHide();
          this.step++;
          this.gaStepsTrack();
          $("html, body").animate({
            scrollTop: 0
          }, 500);
        }
      },
      stepPrev() {
        if (this.step > 1) {
          this.$refs.registrationFrame.scrollTop = 0;
          this.alertHide();
          this.step--;
          this.gaStepsTrack();
          $("html, body").animate({
            scrollTop: 0
          }, 500);
        }
      },
      gaStepsTrack(){
        console.log(dataLayer);
        switch ( this.step )
        {
          case 1:
              dataLayer.push({ 'event': 'virtualPageview', 'virtualPagePath': '/virtual/doctoronline/osobni-udaje', 'virtualPageTitle': 'Virtual - Lékař online - Osobní údaje' });
            break;
          case 2:
              dataLayer.push({ 'event': 'virtualPageview', 'virtualPagePath': '/virtual/doctoronline/identifikacni-udaje', 'virtualPageTitle': 'Virtual - Lékař online - Identifikační údaje' });
            break;
          case 3:
              dataLayer.push({ 'event': 'virtualPageview', 'virtualPagePath': '/virtual/doctoronline/karta-pojistence', 'virtualPageTitle': 'Virtual - Lékař online - Karta pojištěnce' });
            break;
          case 4:
              dataLayer.push({ 'event': 'virtualPageview', 'virtualPagePath': '/virtual/doctoronline/dekujeme', 'virtualPageTitle': 'Virtual - Lékař online - Děkujeme' }); 
            break;
        }
      },
      onFileChange(item, e) {
        const files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;

        // limit 7 MB file
        const MBSize = files[0].size / (1024*1024); 
        if ( MBSize > 7 )
        {
          this.stepThreeForm.healthCard.fileContent = '';
          this.stepThreeForm.FileInputExceeded = true;
        }
        else
        {
          this.stepThreeForm.FileInputExceeded = false;
          this.createImage(item, files[0]);
        }
      },
      onFileDragOver(){
        if ( ! this.stepThreeForm.FileInputDragOver )
        {
          this.stepThreeForm.FileInputDragOver = true
        }
      },
      onFileDragLeave(){
        if ( this.stepThreeForm.FileInputDragOver )
        {
          this.stepThreeForm.FileInputDragOver = false
        }
      },
      createImage(item, file) {
        const image = new Image();
        const reader = new FileReader();

        reader.onload = (e) => {
          item.fileContent = e.target.result;
        };
        reader.readAsDataURL(file);
      },
      stepOneNextForm() {
        this.$v.stepOneForm.$touch()
        if (!this.$v.stepOneForm.$error) {
          this.$Progress.start();
          this.isNextDisabled = true;
          const url = `/api/DoctorOnline/StepOne`;
          axios
            .post(url, { ...this.stepOneForm, session: this.session })
            .then(response => {
              this.$Progress.finish();
              this.isNextDisabled = false;
              this.stepResponse = response.data;
              console.log(this.stepResponse)
              this.session = this.stepResponse.session;
              if (this.stepResponse.isSuccess) {
                this.stepNext();
              } else {
                this.alertShow();
              }
            })
            .catch(error => {
              this.$Progress.finish();
              this.isNextDisabled = false;
              console.log(error);
            });
        }
      },
      stepTwoNextForm() {
        this.$v.stepTwoForm.$touch()
        if (!this.$v.stepTwoForm.$error) {
          this.$Progress.start();
          this.isNextDisabled = true;
          const url = `/api/DoctorOnline/StepTwo`;
          axios
            .post(url, { ...this.stepTwoForm, session: this.session })
            .then(response => {
              this.$Progress.finish();
              this.isNextDisabled = false;
              this.stepResponse = response.data;
              if (this.stepResponse.isSuccess) {
                this.stepNext();
              } else {
                this.alertShow();
              }
            })
            .catch(error => {
              this.$Progress.finish();
              this.isNextDisabled = false;
              console.log(error);
            });
        }
      },
      stepThreeNextForm() {
        this.$Progress.start();
        const url = `/api/DoctorOnline/StepThree`;
        axios
          .post(url, { ...this.stepThreeForm, session: this.session })
          .then(response => {
            this.$Progress.finish();
            this.stepResponse = response.data;
            if (this.stepResponse.isSuccess) {
              this.stepNext();
            } else {
              this.alertShow();
            }
          })
          .catch(error => {
            this.$Progress.finish();
            console.log(error);
          });
      },
      gotoStepOne() {
        this.stepNext()
      },
      alertHide() {
        this.isAlertOpen = false
      },
      alertShow() {
        this.isAlertOpen = true
      }
    }
  });
}
